// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3nwAh","requiredAsterisk":"Info_requiredAsterisk__1ysde"};